import { useState, useEffect } from 'react'

export default function useFileDownload() {
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState('')

  useEffect(() => {
    if (!url || loading) return

    setLoading(true)
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    document.body.appendChild(a)
    a.click()
    a.remove()

    setLoading(false)
    setUrl('')
  }, [url, loading])

  return setUrl
}
